import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardBody, Container, Row, Button } from 'reactstrap';
import { useLocation } from 'react-router-dom';

import Loader from 'components/Loader';
import SimpleHeader from 'components/Headers/SimpleHeader';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import OpportunityList from './components/OpportunitiesList';
import ListLeadssHeader from './components/ListOpportunitiesHeader';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../../hooks/useMemorizeInputsFilters';

import ImportOpportunitiesModal from './components/ImportOpportunitiesModal';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

function LeadsListIndex() {
  const [selectedRecordType, setSelectedRecordType] = useState(null);
  const [formValues, setFormValues] = useState({});
  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(entitiesName.OPPORTUNITY);
  const { getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.CRM_OPPORTUNITY
  );

  const location = useLocation();

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length) {
      const memorizedRecordType = getMemorizedFilters();
      if (!memorizedRecordType?.recordTypeId) {
        setSelectedRecordType(recordTypes[0]);
      } else {
        const recordType = recordTypes.find(
          (rt) => rt.id === memorizedRecordType.recordTypeId
        );
        setSelectedRecordType(recordType || recordTypes[0]);
        if (location.state) {
          setFormValues(location.state);
          const { recordType } = location.state;
          if (recordType) {
            const matchedRecordType = recordTypes.find(
              (rt) => rt.id === recordType
            );
            if (matchedRecordType) {
              setSelectedRecordType(matchedRecordType);
            }
          }
        }
      }
    }
  }, [getMemorizedFilters, recordTypes, location.state]);

  const openModalOpportunityId = location.state?.openModalOpportunityId || null;

  const handleSelectRecordType = useCallback(
    (recordTypeId) => {
      setSelectedRecordType(recordTypes.find((rt) => rt.id === recordTypeId));
    },
    [recordTypes]
  );

  const getChildToRender = () => {
    if (isLoadingRecordTypes) {
      return (
        <div className="col-12">
          <Row className="justify-content-md-center">
            <Loader />
          </Row>
        </div>
      );
    }

    if (!recordTypes && !isLoadingRecordTypes) {
      return (
        <div>
          <span className="small">
            Você não tem acesso a nenhum tipo de oportunidade.
          </span>
        </div>
      );
    }

    return (
      <OpportunityList
        selectedRecordTypeId={selectedRecordType?.id}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
        formValues={formValues}
        openModalOpportunityId={openModalOpportunityId}
      />
    );
  };

  return (
    <>
      <SimpleHeader
        setCreate={`/admin/crm/opportunityForm/${selectedRecordType?.id}`}
        name="Form validation"
        parentName="Forms"
        returnPath="/admin"
        showBackArrow="not"
        role="CRM_OPPORTUNITIES_CREATE"
      >
        {verifyRoles(['CRM_OPPORTUNITIES_CREATE']) && (
          <ImportOpportunitiesModal
            buttonOpenModal={({ onClick }) => (
              <Button onClick={onClick}>Importar</Button>
            )}
          />
        )}
      </SimpleHeader>
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <ListLeadssHeader
                  title="Oportunidades"
                  recordTypes={recordTypes}
                  selectedRecordType={selectedRecordType}
                  handleSelectRecordType={handleSelectRecordType}
                />
                <CardBody className="pt-2">{getChildToRender()}</CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default LeadsListIndex;
